// extracted by mini-css-extract-plugin
export default {"tooltipButton":"tooltip-button_tooltipButton__n3iUN"};